import React, { ComponentState, useEffect, useState } from "react";
import { AppInput } from "../../../../components/Input";
import { ErrorConsts } from "../../../../utils/ErrorCons";
import { AppButtons } from "../../../../components/button";
import { ClientUpdatePinModel, ClientUploadSignModel } from "../../../../dataModel/clientModels";
import { useDispatch, useSelector } from "react-redux";
import { saveGenericSuccessData, updateClientSignsPIN } from "../../../../redux/actions";



export interface SignatureProps {
  onClose(): void,
  title: string,
  clientID: number, isParent: boolean
}

export const UpdatePin = (props: SignatureProps) => {


  const [buttonPressed, setButtonPressed] = useState(false)
  const [pin, setPin] = useState<string>()
  const [Cpin, setCPin] = useState<string>()
  const dispath = useDispatch()

  const state: ComponentState = useSelector(states => {
    return states;
  });
  const { loadingState } = state['LoaderReducer'];




  const handleButtonPressed = () => {
    setButtonPressed(true)
    if (pin && pin.length > 3 && Cpin && Cpin.length > 3) {
      const signRequest: ClientUpdatePinModel = {
        isParentSig: props.isParent,
        pinNumber: pin
      }
      dispath(updateClientSignsPIN(signRequest))
      props.onClose()
    }
  }

  const handleClose = () => {
    dispath(saveGenericSuccessData(false))
    props.onClose()
  }

  return (
    <>
      <div className="modal-wrapper">
        <div className="modal-Div my-3">
          <button className="close-btn" onClick={handleClose}>
            <i className="fa-regular fa-circle-xmark"></i>
            </button>
                <h2 className="mb-3 fw-600">{props.title}
                </h2>
                <form>

                  <AppInput labelText="PIN"
                   
                    maxLength={4}
                    inputType="password"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    showError={buttonPressed && (!pin || pin.length < 4)}
                    errorMessage={ErrorConsts.PIN}
                    onChange={setPin}></AppInput>

                  <AppInput labelText="Confirm PIN"
                    inputType="password"
                    maxLength={4}
                    showError={buttonPressed && (!Cpin || Cpin.length < 1 || Cpin !== pin)}
                    errorMessage={Cpin !== pin ? ErrorConsts.PIN_MISMATCH : ErrorConsts.PIN}
                    onChange={setCPin}></AppInput>
                    
                    <div className="d-flex gap-2 align-items-center">
                  <AppButtons buttonText="Submit" className="btn-common  btn-green" onclick={handleButtonPressed} loadingState={loadingState}></AppButtons>
                  <AppButtons className="btn-common white-btn  text-center" buttonText="Cancel" onclick={handleClose} ></AppButtons>
                  </div> 
                  </form>
              </div>
            </div>
    </>
  )
}